export const scrollTopToElement = (
  elementId: string,
  offset: number = 8
) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  const headerOffset = 75; // Always 75px when scrolled down
  const elementPosition =
    element.getBoundingClientRect().top + window.scrollY;
  const offsetPosition = elementPosition - headerOffset - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
};
